/***
 * Created on 2023/12/27
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import ModalDialog from "../../common/modal_dialog/modalDialog";
import DialogTextInput from "../../common/form/dialog_text_input";
import {useOnChange} from "../../../hook/form";
import {useMutation} from "@tanstack/react-query";
import {apiPut} from "../../../service/api";
import {getErrorMessage, emailPattern} from 'common/ServiceCommon';


function EditEmailDialog({email, state, dispatch, ...props}) {
    const { t } = useTranslation();
    const [errorMessage, setErrorMessage] = useState();
    const {values, setValues, onChange} = useOnChange({
        email: ''
    });
    const modalRef = useRef(null);

    const changeEmailMutation = useMutation({
        mutationFn: async (data) => await apiPut('/ajax/email', data),
        onSuccess: data => {
            dispatch({type: "showVerifyEmail", value: true});
        } ,
        onError: (error, variables, context) => {
            if (error?.cause?.code === 1004011) {
                dispatch({type: "showVerifyPassword", value: true});
            }
            else {
                setErrorMessage(getErrorMessage(t, error.cause?.code));
                modalRef.current.disableSubmitButton(false);
            }
        }
    });

    const onSubmit = () => {
        dispatch({type: "new_email", value: values.email});
        changeEmailMutation.mutate(values);
    }

    useEffect(() => {
        const reg_mail = new RegExp(emailPattern, 'gm');
        if (reg_mail.test(values.email)) {
            modalRef.current.disableSubmitButton(false);
        }
        else {
            modalRef.current.disableSubmitButton(true);
        }
    }, [values.email]);

    return (
        <ModalDialog {...props} title={t('@Change Email@')} submitText={t('@Continue@')} submitAction={onSubmit} ref={modalRef} initDisableSubmit={true}>
            <div className="dialog-content">
                <p className="!mb-16">
                    {t('@This will change the contact and login email address for your account. Please note that if you change your email, this change will take place everywhere this email is used.@')}
                </p>
                <div className="dialog__form-group">
                    <label>{t('@Current Email@')}</label>
                    <input type="text" value={state.old_email} disabled />
                </div>

                <DialogTextInput label={t('@New Email@')} inputMode={"email"} name="email"
                                 value={values.email}
                                 required={true}
                                 pattern="^[a-zA-Z0-9+\-_%\.]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,63}$"
                                 onChange={onChange} />

                {errorMessage && <p className="text-error">{t(errorMessage)}</p>}

                <p className="text-warning">
                    {t('@Warning: If you have joined any organization, you must wait until the organization owner approves your changes before accessing any organizational devices.@')}
                </p>
            </div>
        </ModalDialog>
    );
}

export default EditEmailDialog;